import { useResponsiveGrid } from '@srcDS/components/organisms/categoryProductList/hooks/useResponsiveGrid';

export const useProductViewport = (products: any, gridType: string = 'wide') => {
  const productsInViewport = useResponsiveGrid(products, gridType);

  return (product: any, type: 'promo' | 'product') => {
    return type === 'promo'
      ? !!productsInViewport.find((p) => p.data?.image === product.data?.image)
      : !!productsInViewport.find((p) => p.productId === product.productId);
  };
};
